import React from 'react'

const FormRowWrapper = ({ children, title, hasError, error, fieldName, className }) => (
  <section className={ (className? className : '') + " form-row-wrapper"}>
    <div className="form-row-wrapper__input">
      {title && <label htmlFor={fieldName}>{title}</label>}
      {children}
    </div>
    <div className="form-error">{hasError && error}</div>
  </section>
)

export default FormRowWrapper



// WEBPACK FOOTER //
// ./src/components/common/FormFields/FormRowWrapper/FormRowWrapper.js